export const SHOPPABLE_VIDEO_SECTION_HASH = 'SHOPPABLE_VIDEO'

export const SHOPPABLE_VIDEO_SECTION_TITLE = 'Shoppable Video'
